/**
 * @generated SignedSource<<4f1511016f30960d1bbc443c21231347>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e

import type { ConcreteRequest } from 'relay-runtime';
export type useIsSmartFoldersEnabledQuery$variables = {
  spaceKey: string;
};
export type useIsSmartFoldersEnabledQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes: {
        readonly isFoldersEnabled: boolean;
        readonly isSmartFoldersEnabled: boolean;
      };
    };
  } | null | undefined;
};
export type useIsSmartFoldersEnabledQuery = {
  response: useIsSmartFoldersEnabledQuery$data;
  variables: useIsSmartFoldersEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "SpaceTypeSettings",
        "kind": "LinkedField",
        "name": "spaceTypeSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "EnabledContentTypes",
            "kind": "LinkedField",
            "name": "enabledContentTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFoldersEnabled"
              },
              {
                "kind": "ScalarField",
                "name": "isSmartFoldersEnabled"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsSmartFoldersEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsSmartFoldersEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "544e060744fb4498c2bc0371295ea8f5",
    "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
    "metadata": {},
    "name": "useIsSmartFoldersEnabledQuery",
    "operationKind": "query",
    "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
  }
};
})();

(node as any).hash = "03675b093cffce21dc93e86a9415a3c7";

export default node;
